import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/enterprise-apps/enterprise-apps/apps/pfdn/src/app/integration-guide/IntegrationGuideClient.tsx");
